import styled from "styled-components";

export const ModalContainer = styled.div<{ isMobile?: boolean }>`
  border-radius: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 95vw;
  min-width: ${(props) => (props.isMobile ? "300px" : "560px")};
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 40px 20px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
`;

export const ModalContentContainer = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ButtonAreaContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  width: 100%;
  gap: 16px;

  @media screen and (max-width: 760px) {
    flex-direction: column;
    gap: 12px;
  }
`;
